import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { NotificationProvider } from "@/hooks/useNotifications";
import { store } from "@/store";
import { PwaAssistantHost } from "@/components/feature/PwaAssistantHost";

function App() {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <NotificationProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
            {/* A sibling of the routes, not a child of any page: the router never
                unmounts, so the conversation survives every navigation. */}
            <PwaAssistantHost />
          </BrowserRouter>
        </NotificationProvider>
      </I18nextProvider>
    </Provider>
  );
}

export default App;
